<template>
  <div>
    <v-checkbox
      class="panel-checkbox"
      multiple
      hide-details
      v-for="value in filter"
      :key="value.id"
      :value="value.id"
      :disabled="value.filteredCount == 0"
      v-model="selectedFacetsXS[facet.parameterName]"
      :label="`${value.name} (${value.filteredCount})`"
      @click="handleFacetFilterMobile()"
    >
    </v-checkbox>
    <a
      v-if="facet.values.length > 6 && panelLength == 6"
      class="caption d-flex align-center justify-center mt-2 primary--text"
      @click="panelLength = facet.values.length"
    >
      <span>Mostra di più</span>
      <v-icon color="primary">mdi-chevron-down</v-icon>
    </a>
    <a
      v-else-if="facet.values.length > 6"
      class="caption d-flex align-center justify-center mt-2 primary--text"
      @click="panelLength = 6"
    >
      <span>Mostra di meno</span>
      <v-icon color="primary">mdi-chevron-up</v-icon>
    </a>
  </div>
</template>
<script>
import cloneDeep from "lodash/cloneDeep";
export default {
  name: "FilterCheckboxList",
  data() {
    return {
      panelLength: 6
    };
  },
  props: {
    facet: { type: Object },
    facetsFilter: { type: Object }
  },
  computed: {
    selectedFacetsXS() {
      return cloneDeep(this.facetsFilter);
    },
    filter() {
      return this.facet.values.slice(0, this.panelLength);
    }
  },
  methods: {
    handleFacetFilterMobile() {
      this.$emit("handleFacetFilterMobile", this.selectedFacetsXS);
    }
  }
};
</script>
